
export default function LearnHero() {
  return (
    <section className="relative bg-[#1A1A1A] text-white py-20 md:py-32 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h1
          className="text-[30px] md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Learn from the Pros. Do It Yourself.
        </h1>
        <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto px-2">
          Step-by-step video guides for tiling, grouting, painting, and more — with the products the pros trust.
        </p>
      </div>
    </section>
  );
}
